import { AB_TEST_EVALUATOR_FUNCTION as DEFAULT_AB_TEST_EVALUATOR_FUNCTION } from '@shopee-user/shared-customization-logic';
import type { AbTestExperimentEvaluatorMap } from '@shopee-user/business-customization-types';

export const AB_TEST_EVALUATOR_FUNCTION: AbTestExperimentEvaluatorMap = {
  ...DEFAULT_AB_TEST_EVALUATOR_FUNCTION,
};
